// extracted by mini-css-extract-plugin
export var option = "_dg-0";
export var optionCard = "_dg-f";
export var optionContent = "_dg-g";
export var optionIcon = "_dg-i";
export var optionIconBox = "_dg-h";
export var optionLabel = "_dg-j";
export var optionPill = "_dg-m";
export var optionPillBadge = "_dg-p";
export var optionPillIcon = "_dg-n";
export var optionPillLabel = "_dg-o";
export var optionRadio = "_dg-k";
export var optionRadioInner = "_dg-l";
export var optionReveal = "_dg-2";
export var optionRevealDelay0 = "_dg-3";
export var optionRevealDelay1 = "_dg-4";
export var optionRevealDelay10 = "_dg-d";
export var optionRevealDelay11 = "_dg-e";
export var optionRevealDelay2 = "_dg-5";
export var optionRevealDelay3 = "_dg-6";
export var optionRevealDelay4 = "_dg-7";
export var optionRevealDelay5 = "_dg-8";
export var optionRevealDelay6 = "_dg-9";
export var optionRevealDelay7 = "_dg-a";
export var optionRevealDelay8 = "_dg-b";
export var optionRevealDelay9 = "_dg-c";
export var optionSelected = "_dg-1";